<template>
  <div class="log">
    <button
      v-if="!hideTrigger && !subJobDetail.isCustomerReceiptInitiated"
      @click.stop="dialog = false"
      @click="check()"
      title="Edit Customer Price"
      aria-label="Edit Customer Price"
      target="_blank"
      class="view-ass-btn"
      :disabled="processing || viewOnly == 'view'"
    >
      Edit
    </button>

    <v-dialog
      v-model="dialog"
      content-class="price-edit-dialog"
    >
      <v-form ref="form" onsubmit="return false;">
        <v-card class="pe-card">
          <div class="pe-head">
            <span class="pe-head__icon"><v-icon>payments</v-icon></span>
            <div class="pe-head__text">
              <strong>Edit customer price</strong>
              <span>Job {{ jobId }}</span>
            </div>
            <v-btn
              icon
              class="pe-head__close"
              :disabled="processing"
              @click.prevent="dialog = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <v-progress-linear
            indeterminate
            color="orange"
            height="3"
            class="pe-progress"
            v-show="processing"
          ></v-progress-linear>

          <div class="pe-body">
            <div class="pe-current">
              <span class="pe-label">Current price</span>
              <strong
                >{{ x.customerCurrency }}
                {{ $formatPrice(subJobDetail.subJobPrice) }}</strong
              >
            </div>
            <div class="pe-field">
              <span class="pe-label">New price *</span>
              <v-text-field
                v-model="x.subJobPrice"
                type="number"
                min="0"
                :suffix="x.customerCurrency"
                class="pe-input"
                hide-details
                autofocus
                @keyup.enter="checkStatus(detail.customerId, x.subJobPrice)"
              ></v-text-field>
            </div>
            <div v-if="haserror && x.error" class="pe-error">
              <v-icon small>error_outline</v-icon>
              <span>{{ x.error }}</span>
            </div>
          </div>

          <div class="pe-actions">
            <v-btn
              flat
              class="pe-btn pe-btn--ghost"
              :disabled="processing"
              @click="dialog = false"
              >Cancel</v-btn
            >
            <v-btn
              flat
              class="pe-btn pe-btn--primary"
              :disabled="processing"
              @click="checkStatus(detail.customerId, x.subJobPrice)"
              >Save price</v-btn
            >
          </div>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog
      v-model="dialog1"
      persistent
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
      content-class="price-edit-dialog price-edit-dialog--warning"
    >
      <v-card class="pe-card">
        <div class="pe-head pe-head--warning">
          <span class="pe-head__icon"><v-icon>warning_amber</v-icon></span>
          <div class="pe-head__text">
            <strong>Credit limit exceeded</strong>
            <span>Review before saving the new price.</span>
          </div>
          <v-btn
            icon
            class="pe-head__close"
            :disabled="processing"
            @click.prevent="dialog1 = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <div class="pe-body">
          <div v-if="creditLimitError" class="pe-warning">
            {{ creditLimitError }}
          </div>
          <p class="pe-text">Are you sure you want to edit the price?</p>
        </div>
        <div class="pe-actions">
          <v-btn
            flat
            class="pe-btn pe-btn--ghost"
            :disabled="processing"
            @click="dialog1 = false"
            >Cancel</v-btn
          >
          <v-btn
            flat
            class="pe-btn pe-btn--primary"
            :loading="processing"
            @click.native="addCharges()"
            >Save anyway</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import ErrorBox from "@/components/Common/ErrorBox";
import { editJobPrice, checkCreditLimit } from "@/constants/api-urls.js";
import SuccessDialog from "@/components/Common/SuccessDialog";
import { StorageKeys, Currencies } from "../../constants/constants";
import CustomerCurrency from "@/components/Common/CustomerCurrency";
export default {
  data() {
    return {
      creditLimitError: "",
      options: {
        color: "#ffc04c",
        width: 400,
        zIndex: 200,
      },
      dialog1: false,
      operationName: "",
      x: {
        error: null,
        jobPrice: null,
        customerCurrency: null,
        subJobPrice: null,
      },
      amount: null,
      items: [],
      currencies: [],
      processing: false,
      reason: "",
      dialog: false,
      disStatus: false,
      haserror: false,
      loading: false,
      rules: {
        // required: value => !!value || "This field is required.",
        emailRules: (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/.test(v) ||
          "E-mail must be valid",
        countryCode: (v) =>
          /^(\+?\d{1,3}|\d{1,4})$/.test(v) ||
          "Please Enter Valid Country Code.",
        phoneNumber: (v) =>
          /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/.test(v) ||
          "Please Enter Valid Mobile No.",
        number: (v) => /^[0-9]*$/.test(v) || "Please Enter Valid Price",
      },
    };
  },
  props: ["jobId", "detail", "subJobDetail", "working", "viewOnly", "hideTrigger"],

  created() {
    if (this.$props.working) {
      if (this.$props.working == "UAE") {
        this.x.customerCurrency == "AED";
      }
      if (this.$props.working == "PAK") {
        this.x.customerCurrency == "PKR";
      }
      if (this.$props.working == "KSA") {
        this.x.customerCurrency == "SAR";
      }
      if (this.$props.working == "OMAR") {
        this.x.customerCurrency == "OMR";
      }
    }

    this.x.error = null;
    this.haserror = false;
    this.currencies = Currencies;
    // this.x.customerCurrency = this.detail.customerCurrency;
  },
  components: {
    ErrorBox,
    CustomerCurrency,
    SuccessDialog,
  },
  methods: {
    cancel() {
      this.dialog = false;
      this.dialog1 = false;
    },
    async check() {
      this.operationName = "edit-price";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.open();
      } else {
        return;
      }
    },
    closeMessage() {
      this.processing = false;
      this.x.success = false;
      this.isEmail = true;
    },
    open() {
      this.dialog = true;
      this.x.error = null;
      this.haserror = false;
      this.currencies = Currencies;
      this.x.subJobPrice = this.subJobDetail.subJobPrice;

      this.x.customerCurrency = this.detail.customerCurrency;
    },
    checkStatus(id, amount) {
      this.haserror = false;
      if (this.x.subJobPrice == null) {
        this.x.error = "Please enter price.";
        this.haserror = true;
        return;
      }
      // if (!this.x.subJobPrice.match(/^[0-9]*$/)) {
      //   this.x.error = "Please enter valid price.";
      //   this.haserror = true;
      //   return;
      // }
      if (this.x.subJobPrice == 0) {
        this.x.error = "Please enter valid price.";
        this.haserror = true;
        return;
      }
      if (this.x.subJobPrice >= 1000000000000) {
        this.x.error = "Please enter amount less than 1000000000000";
        this.haserror = true;
        return;
      }

      // if (!this.x.subJobPrice.trim()) {
      //   this.x.error = "Please enter valid price.";
      //   this.haserror = true;
      //   return;
      // }
      // var value = /^[0-9]*$/.test(this.x.subJobPrice.trim());
      // if (!value) {
      //   this.x.error = "Please enter valid price.";
      //   this.haserror = true;
      //   return;
      // }

      if (!this.x.customerCurrency || this.x.customerCurrency == undefined) {
        this.x.error = "Please select the currency.";
        this.haserror = true;
        return;
      }
      if (this.subJobDetail.isDriverJob) {
        if (this.x.subJobPrice < this.subJobDetail.amountForTransporter) {
          this.x.error =
            "Job price cannot be less than bid price(" +
            this.subJobDetail.amountForTransporter +
            ").";
          this.haserror = true;
          return;
        }
      }

      if (this.subJobDetail.isTransporterJob) {
        if (this.x.subJobPrice < this.subJobDetail.amountForTransporter) {
          this.x.error =
            "Job price cannot be less than bid price(" +
            this.subJobDetail.amountForTransporter +
            ").";
          this.haserror = true;
          return;
        }
      }

      this.loading = true;
      let url = checkCreditLimit;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        userId: id.toString(),
        price: amount.toString(),

        // inquiryStatus:status
      };
      // if(this.statusComments){
      //   body.comments = this.statusComments.trim();
      // }
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          if (response.status === 200) {
            this.addCharges();
            //  this.dialog = false;
            this.loading = false;
          }
        },
        (error) => {
          this.loading = false;

          if (error.response.data.statusCode === 400) {
            this.x.error = error.response.data.message;
          }
          if (error.response.data.statusCode === 402) {
            this.x.error = error.response.data.message;
            this.dialog1 = true;
            this.creditLimitError = error.response.data.message;
            this.dialog = false;
          } else {
            this.x.error = error.response.data.message;
          }
          setTimeout(() => {
            this.x.error = "";
          }, 3000);
        }
      );
    },
    async addCharges() {
      console.log("----------edit");
      this.processing = true;
      this.operationName = "edit-price";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        let url = editJobPrice;
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };
        var jobPrice =
          parseFloat(this.detail.jobPrice) -
          parseFloat(this.subJobDetail.subJobPrice) +
          parseFloat(this.x.subJobPrice);
        console.log(jobPrice);
        if (this.detail.jobPrice == undefined) {
          jobPrice = this.x.subJobPrice;
        }
        console.log(jobPrice);
        console.log("--change", typeof this.x.subJobPrice, this.x.subJobPrice);
        var perAssignmentPrice =
          this.x.subJobPrice / this.subJobDetail.assignNotCancelledCount;
        var body = {
          jobPrice: jobPrice.toFixed(2).toString(),
          jobId: this.jobId.toString(),
          jobCurrency: this.x.customerCurrency,
          subJobPrice: Number(this.x.subJobPrice).toFixed(2).toString(),
          tabOrder: this.subJobDetail.tabOrder
            ? this.subJobDetail.tabOrder.toString()
            : "1",
          jobType: this.subJobDetail.tabOrder
            ? this.subJobDetail.jobType.toString()
            : "1",
          perAssignmentPrice: perAssignmentPrice.toFixed(2).toString(),
        };

        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            var amount = this.amount;
            this.$eventBus.$emit("additional-charges-added", amount);
            //this.$eventBus.$emit("refresh-job");
            this.amount = null;
            this.comments = null;
            this.processing = false;
            this.x.success = true;
            this.cancel();
            this.x.error = null;
            this.haserror = false;
          },
          (error) => {
            this.processing = false;
            this.dialog = true;
            this.haserror = true;
            this.x.error = error.response.data.message;
          }
        );
      } else {
        this.processing = false;
        return;
      }
    },
  },
};
</script>
<style scoped>
.break_long_text {
  word-break: break-all;
  word-break: break-word;
  hyphens: auto;
}
.user {
  padding: 10px;
}
.comments-view .v-toolbar {
  width: 100%;
  /* margin-left: 25%; */
}
.v-toolbar--fixed {
  position: inherit;
}
.assign-driver-btn {
  text-decoration: none;
  color: #ffffff;
  background-color: #bebebe;
  border: 2px solid grey;
  padding: 2px 5px;
  border-radius: 5px;
}

.view-ass-btn {
  text-decoration: none;
  color: #ffffff;
  background-color: #c87ffe;
  border: 2px solid indigo;
  padding: 2px 5px;
  border-radius: 5px;
}

.oms-job-price-dialog-card {
  border-radius: 10px !important;
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.18) !important;
  overflow: hidden;
}

.oms-job-price-dialog-card .v-toolbar {
  background: #fff7ed !important;
  border-bottom: 1px solid #fed7aa;
  color: #172033 !important;
}

.oms-job-price-dialog-card .v-toolbar__title {
  color: #172033 !important;
  font-size: 15px;
  font-weight: 900;
}

.oms-job-price-dialog-card .v-card__text {
  background: #ffffff;
  padding: 12px !important;
}

.oms-job-price-dialog-card .v-card__actions {
  border-top: 1px solid #e4e7ec;
  padding: 10px 12px !important;
}

.oms-job-price-dialog-card .v-card__actions .v-btn {
  border-radius: 7px !important;
  box-shadow: none !important;
  font-weight: 900;
  letter-spacing: 0;
  text-transform: none;
}
</style>
